import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ErrorMessage } from '@classes/error-message';
import { ErrorMessageData } from '@classes/error-message-data';
import { TollMessage } from '@classes/toll-message';
import { TonnageMessage } from '@classes/tonnage-message';
import { Role } from '@enums/role.enum';
import { TollMessageService } from 'app/core/services/toll-message.service';
import { TonnageMessageService } from 'app/core/services/tonnage-message.service';
import { UiService } from 'app/core/services/ui.service';
import { MessageBox } from '@components/message-box/message-box.component';
import { MessageBoxParameter } from '@classes/message-box-parameter';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-error-message',
  templateUrl: './error-message.component.html',
  styleUrls: ['./error-message.component.scss']
})
export class ErrorMessageComponent implements OnInit {

  errorMessageForm: FormGroup;
  errorMessages: ErrorMessage[] = [];
  Role = Role;

  constructor(
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<ErrorMessageComponent>,
    public tollMessageService: TollMessageService,
    public tonnageMessageService: TonnageMessageService,
    public uiService: UiService,
    private translateService: TranslateService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: ErrorMessageData,
  ) { }

  ngOnInit() {
    this.initFormBuilder();
    if (!this.data.isReport) {
      this.getErrorMessage();
    }
  }

  private initFormBuilder(value?: any) {
    const fb = this.formBuilder;
    this.errorMessageForm = fb.group({
      message: fb.control('', [Validators.required]),
      tollId: fb.control(this.data?.tollID),
      tonnageId: fb.control(this.data?.tonnageID)
    });
  }

  getErrorMessage() {
    if (this.data.tollID) {
      this.getTollErrorMessage(this.data.tollID);
    } else if (this.data.tonnageID) {
      this.getTonnageErrorMessage(this.data.tonnageID);
    }
  }
  getTollErrorMessage(id: string) {
    this.uiService.addRouteLoading();
    this.tollMessageService.getTollMessages(id).subscribe(data => {
      this.errorMessages = data.map(m => new ErrorMessage({
        id: m.id,
        message: m.message,
        tollId: m.tollId,
        tonnageId: null,
        creationDate: m.creationDate,
        creationUser: m.creationUser
      })).sort((a, b) => new Date(a.creationDate).getTime() - new Date(b.creationDate).getTime());
      this.uiService.removeRouteLoading();
    }, error => {
      console.error(error);
      this.uiService.removeRouteLoading();
    });
  }
  getTonnageErrorMessage(id: string) {
    this.uiService.addRouteLoading();
    this.tonnageMessageService.getTonnageMessages(id).subscribe(data => {
      this.errorMessages = data.map(m => new ErrorMessage({
        id: m.id,
        message: m.message,
        tonnageId: m.tonnageId,
        tollId: null,
        creationDate: m.creationDate,
        creationUser: m.creationUser
      })).sort((a, b) => new Date(a.creationDate).getTime() - new Date(b.creationDate).getTime());
      this.uiService.removeRouteLoading();
    }, error => {
      console.error(error);
      this.uiService.removeRouteLoading();
    });
  }

  onCancel() {
    this.dialogRef.close(false);
  }
  onSubmit() {
    this.sendErrorMessage();
  }

  sendErrorMessage() {
    if (this.data.tollID) {
      this.sendTollErrorMessage();
    } else if (this.data.tonnageID) {
      this.sendTonnageErrorMessage();
    }
  }
  sendTollErrorMessage() {
    const tollMessage = new TollMessage(this.errorMessageForm.value);
    this.tollMessageService.postTollMessage(tollMessage).subscribe(
      data => {
        this.uiService.displayMessageToast('error-message.success-send');
        this.dialogRef.close(true);
      },
      error => {
        console.error(error);
      }, () => {
        this.uiService.removeRouteLoading();
      }
    );
  }
  sendTonnageErrorMessage() {
    const tonnageMessage = new TonnageMessage(this.errorMessageForm.value);
    this.uiService.addRouteLoading();
    this.tonnageMessageService.postTonnageMessage(tonnageMessage).subscribe(
      data => {
        this.uiService.displayMessageToast('error-message.success-send');
        this.dialogRef.close(true);
      },
      error => {
        console.error(error);
      }, () => {
        this.uiService.removeRouteLoading();
      }
    );
  }
  onRemoveError() {

    const messageBoxParameter: MessageBoxParameter = {
      message: this.translateService.instant('error-message.on-remove-error'),
      dialog: this.dialog,
      title: 'Confirmation',
      buttons: ['yes', 'no'],
      width: "400px"
    };
    MessageBox.show(messageBoxParameter).subscribe(mbResult => {
      if (mbResult && mbResult.value) {
        if (this.data.tollID) {
          this.removeTollError();
        } else if (this.data.tonnageID) {
          this.removeTonnageError();
        }
      }
    });


  }
  removeTollError() {
    const tollMessage = new TollMessage(this.errorMessageForm.value);
    this.tollMessageService.removeError(tollMessage).subscribe(
      data => {
        this.uiService.displayMessageToast('error-message.success-remove-error-satus');
        this.dialogRef.close(true);
      },
      error => {
        console.error(error);
      }, () => {
        this.uiService.removeRouteLoading();
      }
    );
  }
  removeTonnageError() {
    const tonnageMessage = new TonnageMessage(this.errorMessageForm.value);
    this.tonnageMessageService.removeError(tonnageMessage).subscribe(
      data => {
        this.uiService.displayMessageToast('error-message.success-remove-error-satus');
        this.dialogRef.close(true);
      },
      error => {
        console.error(error);
      }, () => {
        this.uiService.removeRouteLoading();
      }
    );
  }
}
